module.exports = __webpack_public_path__ + "static/media/whats.953a8c3e.png";